<div class="text-white allParent" *ngIf="review" [ngClass]="{'inverted': invert}">

    <div class="image">
        <img class="mover" width="100%" [src]="pictureDefault()" [alt]="review.movie.title">
        <div class="fade mover"></div>
    </div>

    <div class="p-5">

        <div class="cont">

            <div class="py-4 px-0">
                <div class="col-8 offset-2 px-0">
                    <div class="originalComment p-4 cm-bg-color-2">
                        <div class="head">
                            <div class="title">{{review.movie.title}}</div>
                            <div class="date">{{review.createdTime | FormatDate}}</div>
                        </div>

                        <div class="d-flex  mb-4">
                            <span class="author mr-2">{{authorFullName(review)}}</span>
                            <app-raiting *ngIf="review.score" [score]="review.score"></app-raiting>
                        </div>

                        <div class="originalCommentText">
                            <p class="m-0" [innerHTML]="review.comment">
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- RESPUESTAS -->
            <div class="replySeccion pt-5">

                <!-- NUEVA RESPUESTA -->
                <div class="newReply" *ngIf="canReply && review.comment.length > 0">
                    <div class="replyParent px-4 pt-4 pb-3 col-8 offset-2 cm-bg-color-2">
                        <form [formGroup]="commentForm">
                            <div class="form-group">
                                <textarea class="form-control commentTextArea" id="commentTextArea"
                                    formControlName="comment" rows="4"
                                    placeholder="Escriba una respuesta ..."></textarea>
                            </div>
                        </form>
                        <div class="botonSend">
                            <div class="px-0 buttonContainter">
                                <button class=" btn cm-bg-color-11 px-4 text-white rounded-1"
                                    (click)="onClickEnviar($event)" [disabled]="loading || !commentForm.value.comment ">
                                    <span *ngIf="!loading"> Enviar respuesta </span>
                                    <span *ngIf="loading" class="spinner-border spinner-border-sm mx-5" role="status"
                                        aria-hidden="true"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- LISTA DE RESPUESTAS -->
                <div class="replyList pt-4" *ngIf="replies.length > 0">
                    <div class="titleText pl-0 py-3 col-8 offset-2">
                        Respuestas: {{replies.length}}
                    </div>
                    <div *ngFor="let reply of replies">
                        <div class="replyListParent p-3 mb-3 col-8 offset-2 cm-bg-color-2">
                            <div class="row px-3">
                                <div class="replyInfo col-12 col-lg-3 pr-lg-0">
                                    <div class="row">
                                        <a href="perfil/{{reply.author.id}}" class="replyName">
                                            {{reply.author.fullName}}
                                        </a>
                                    </div>
                                    <div class="row pt-1 replyTime">
                                        {{reply.formatedTime}}
                                    </div>
                                </div>
                                <div class="col-12 col-lg-9 pl-0 pr-lg-0 replyText">
                                    <p class="replyText" [innerHTML]="reply.comment">
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12 pt-3 noReplies" *ngIf="replies.length == 0 && review.comment.length > 0">
                    Ninguna respuesta aun.
                </div>
                <div class="col-12 pt-3 noReplies" *ngIf="review.comment.length == 0">
                    Esta valoracion no acepta respuestas.
                </div>
            </div>

            <button class="py-3 pr-3 mb-3 close btn cm-tx-color-11" (click)="close()">Cerrar</button>

        </div>
    </div>
</div>